import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/bootstrap.css';
import './assets/css/bootstrap.css.map';
import './assets/css/soft-ui-dashboard.css';
import './assets/css/soft-ui-dashboard.css.map';
import './index.css';
import './assets/css/customcss.css'
import './assets/css/progressbarstyle.css'
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
